import { DateField, SelectField, TextField } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const GlobalSearchDesktopInvoices = props => (
  <Fragment>
    <div>
      <TextField name="InvoiceNumber" title={i18n.t('globalSearch:Invoice #')} value={props.formData.InvoiceNumber} onChange={props.onFormChange} />
      <TextField name="MaxxamJobNumber" title={i18n.t('globalSearch:Job #')} value={props.formData.MaxxamJobNumber} onChange={props.onFormChange} />
      <SelectField name="SubmissionTypeId" title={i18n.t('globalSearch:Submission Type')} value={props.formData.SubmissionTypeId} onChange={props.onFormChange} options={props.submissionTypeOptions} />
    </div>
    <div>
      <TextField name="ProjectNumber" title={i18n.t('globalSearch:Project #')} value={props.formData.ProjectNumber} onChange={props.onFormChange} />
      <TextField name="InvoiceAttention" title={i18n.t('globalSearch:Invoice Attention')} value={props.formData.InvoiceAttention} onChange={props.onFormChange} />
      <SelectField name="Paid" title={i18n.t('globalSearch:Status')} value={props.formData.Paid} onChange={props.onFormChange} options={props.invoiceStatusOptions} />
    </div>
    <div>
      <TextField name="SiteLocationOrSiteNumber" title={i18n.t('globalSearch:Site Location / Site #')} value={props.formData.SiteLocationOrSiteNumber} onChange={props.onFormChange} />
      <TextField name="ReportAttention" title={i18n.t('globalSearch:Report Attention')} value={props.formData.ReportAttention} onChange={props.onFormChange} />
      <SelectField name="ClientNumber" title={i18n.t('globalSearch:Client')} value={props.formData.ClientNumber} onChange={props.onFormChange} options={props.clientOptions} />
    </div>
    <div>
      <TextField name="POAFENumber" title={i18n.t('globalSearch:PO #')} value={props.formData.POAFENumber} onChange={props.onFormChange} />
      <TextField name="TaskOrderNumber" title={i18n.t('globalSearch:Task Order #')} value={props.formData.TaskOrderNumber} onChange={props.onFormChange} />
      <div className="global-search__desktop__container__grid__split">
        <DateField name="DateFrom" title={i18n.t('globalSearch:Invoiced From')} value={props.formData.DateFrom} onChange={props.onFormChange} />
        <DateField name="DateTo" title={i18n.t('globalSearch:Invoiced To')} value={props.formData.DateTo} onChange={props.onFormChange} />
      </div>
    </div>
  </Fragment>
);

GlobalSearchDesktopInvoices.propTypes = {
  onFormChange: PropTypes.func,
  formData: PropTypes.shape({
    SampleID: PropTypes.string,
    Paid: PropTypes.string,
    InvoiceNumber: PropTypes.string,
    OrderNumber: PropTypes.string,
    TaskOrderNumber: PropTypes.string,
    CreatedBy: PropTypes.string,
    WayBill: PropTypes.string,
    MaxxamJobNumber: PropTypes.string,
    MaxxamSampleNumber: PropTypes.string,
    ECoCNumber: PropTypes.string,
    CoCNumber: PropTypes.string,
    Attention: PropTypes.string,
    Status: PropTypes.string,
    invoiceNumber: PropTypes.string,
    Description: PropTypes.string,
    InvoiceAttention: PropTypes.string,
    SubmissionTypeId: PropTypes.number,
    ProjectNumber: PropTypes.string,
    ReportAttention: PropTypes.string,
    ClientNumber: PropTypes.string,
    SiteLocationOrSiteNumber: PropTypes.string,
    CreatedByName: PropTypes.string,
    DateType: PropTypes.string,
    POAFENumber: PropTypes.string,
    ModifiedByName: PropTypes.string,
    DateFrom: PropTypes.string,
    DateTo: PropTypes.string,
  }),
  clientOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })),
  invoiceStatusOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default GlobalSearchDesktopInvoices;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchDesktop/GlobalSearchDesktopInvoices/GlobalSearchDesktopInvoices.jsx